import { render, staticRenderFns } from "./StartTradingSteps.vue?vue&type=template&id=25fca7b8"
import script from "./StartTradingSteps.vue?vue&type=script&lang=js"
export * from "./StartTradingSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StartTradingSteps.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IvestorAppButton: require('/vercel/path0/components/micro/IvestorAppButton.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default,DfmAppButton: require('/vercel/path0/components/micro/dfmAppButton.vue').default})
